import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

async function loadPolyfills() {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
}

loadPolyfills();

export function useExternalScript(initialUrl = '') {
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px 200px 0px',
    threshold: 0,
  });
  const [url, setUrl] = useState(initialUrl);
  const [loaded, setLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  function handleOnLoad() {
    // console.log(`Loaded!`);
    setLoaded(true);
    setHasError(false);
  }

  function handleOnError(hasError) {
    // console.log(`Error!`);
    setLoaded(false);
    setHasError(true);
  }

  useEffect(() => {
    if (!inView) return;

    const script = document.createElement('script');
    setLoaded(false);

    if (!url.length) return;

    script.src = url;
    script.async = true;
    script.defer = 'defer';

    script.onload = handleOnLoad;
    script.onerror = handleOnError;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url, inView]);

  return [ref, loaded, hasError, setUrl];
}
